import React, { useEffect } from 'react'
import { useState } from 'react'
import CircleIcon from '../Common/CircleIcon'
import Input from '../Common/Input'
import Svgs from '../Common/Svgs'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import Button from '../Common/Button'
import axios from 'axios'
import {getNoParams} from '../Common/Api'

// console.log(props.State);
const appUrl = "http://feedback.savourfoods.com.pk"; // Live App URL
const url = "http://182.176.94.28:88/"; // Live API UR
// const appUrl = "http://localhost:3000"; // Local App URL
// const url = "http://localhost:38666/"; // Local API URL

const headers = {
    'Content-Type': 'multipart/form-data',
    'Authorization': 'nE0A8Um109Yrv0BHbf0BEpWd0aB0EqxvnDSfUnVwryqHFbc2+sxfwsjQssLRXKud',
    'Access-Control-Allow-Origin': appUrl,
    'Access-Control-Allow-Methods': 'GET, POST',
    'Access-Control-Allow-Headers': 'Content-Type, Authorization',
    'Access-Control-Allow-Credentials': 'true'
}

const Eight = (props) => {
    // console.log('====================================');
    // console.log(props.State);
    // console.log('====================================');
    const [Text, setText] = useState([]);
    const [state, setState] = useState({ phone: "" });
    const [error, setError] = useState({
        name: '',
        age: '',
        email: '',
        branch: '',
        phone: '',
        gender: '',
        error: 'All fields with (*) are required.'
    })
    const handleInputChangeName = (param) => {
        props.setState({ ...props.State, name: param.target.value });

        // setError((prev) => ({
        //     ...prev,
        //     name: param.target.value ? '' : 'Name is required',
        // }));
    }
    const handleInputChangeAge = (param) => {
        props.setState({ ...props.State, age: param.target.value });

        // setError((prev) => ({
        //     ...prev,
        //     age: param.target.value ? '' : 'Age is required',
        // }));
    }
    const handleInputChangeEmail = (param) => {
        props.setState({ ...props.State, email: param.target.value });

        setError((prev) => ({
            ...prev,
            email: validateEmail(param.target.value) ? '' : 'Email is not valid',
            // email: param.target.value ? validateEmail(param.target.value) ? '' : 'Email is not valid' : 'Email is required',
        }));
    }
    const handleInputChangeBranch = (param) => {
        props.setState({ ...props.State, branch: param.target.value });

        // setError((prev) => ({
        //     ...prev,
        //     branch: param.target.value ? '' : 'Branch is required',
        // }));
    }
    const handleInputChangePhone = (e) => {
        props.setState({ ...props.State, phone: e });

        // setError((prev) => ({
        //     ...prev,
        //     phone: e ? '' : 'Phone is required',
        // }));
    }

    const handleInputChangeGender = (param) => {
        props.setState({ ...props.State, gender: param });

        // setError((prev) => ({
        //     ...prev,
        //     gender: param ? '' : 'Gender is required',
        // }));
    }
    async function mediaBlob(mediaBlobUrl) {
        const mediaBlob = await fetch(mediaBlobUrl).then(response => response.blob());
        const myFile = new File(
            [mediaBlob],
            "video.mp4",
            { type: 'video/mp4' }
        );
        //props.setState({ ...props.State, videoFile: myFile });
        return myFile;
    }

    const handleChange = (param) => {
        // console.log(props.State);
        const errorValues = {
            name: props.State.name ? '' : 'Name is required',
            age: props.State.age ? '' : 'Age is required',
            email: props.State.email ? validateEmail(props.State.email) ? '' : 'Email is not valid' : '',
            // email: props.State.email ? validateEmail(props.State.email) ? '' : 'Email is not valid' : 'Email is required',
            branch: props.State.branch ? '' : 'Branch is required',
            phone: props.State.phone ? '' : 'Phone is required',
            gender: props.State.gender ? '' : 'Gender is required',
        }

        setError(prev => ({
            ...prev,
            ...errorValues
        }));

        const isErrorFound = Object.values(errorValues).some(err => err)
        if (isErrorFound) {
            setError((prev) => ({
                ...prev,
                error: param ? '' : 'All fields with (*) are required.',
            }));
            return
        }

        debugger;
        const video = new File([props.State.video], "video.mp4");
        const audio = new File([props.State.audio], "audio.mp3");
        const formData = new FormData();
        formData.append('video', video);
        formData.append('audio', audio);
        for (const key in props.State) {
            if (props.State.hasOwnProperty(key)) {
                formData.append(key, props.State[key]);
            }
        }
        
        // const headers = { "Content-Type": "multipart/form-data", 'Authorization': 'nE0A8Um109Yrv0BHbf0BEpWd0aB0EqxvnDSfUnVwryqHFbc2+sxfwsjQssLRXKud' };

        axios.post(url + 'api/Surveys/add', formData, { headers })
            .then(response => {
                props.State.video = "";
                props.State.audio = "";
                props.State.name = "";
                props.State.gender = "";
                props.State.email = "";
                props.State.experiance = "";
                props.State.hear = "";
                props.State.lang = "";
                props.State.like = "";
                props.State.phone = "";
                props.State.recommend = '';
                props.State.return = '';
                props.State.revisit = '';
                props.State.suggestions = '';
                props.State.firstVisit = '';
                props.setActive(props.Active + 1)
            })
            .catch((error) => { console.log(error) });
    }

    useEffect(() => {
        setText(props.Language)
    }, [props.Language])

    const [items, setItems] = useState([]);

    useEffect(() => {
        fetchData();
      }, []);

    const fetchData = async () => {
      try {
        const response = await getNoParams('api/Surveys/getBranches'); // Replace 'data' with your API endpoint
        setItems(response.model);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    // useEffect(() => {
    //     // Fetch data from the API
    //     const fetchData = async () => {
    //         try {
    //             const response = await get('api/Surveys/getBranches'); // Replace 'data' with your API endpoint
    //             setItems(response.data.model);
    //         } catch (error) {
    //             console.error('Error fetching data:', error);
    //         }
    //     };
    //     //axios.get(url + 'api/Surveys/getBranches', { headers })
    //     //    .then(response => {
    //     //        debugger;
    //     //        setItems(response.data.model);
    //     //    })
    //     //    .catch(error => {
    //     //        console.error('Error fetching data:', error);
    //     //    });
    // }, []);

    return (
        <div className='slide-in-right  flex flex-col gap-6 items-center'>
            <h1 className={`text-3xl font-extrabold ${Text?.lang == 'UR' && 'urdu'}`}>{Text.text}</h1>
            <div className={`flex flex-col items-center gap-5 ${Text?.lang == 'UR' && 'urdu'}`}>
            <ValidationError error={error.error} />
                <Input value={props.State.name} onChange={handleInputChangeName} placeholder={Text?.options ? Text.options[0] + ' (*)' : ''} />
                {/* <ValidationError error={error.name} /> */}

                <Input value={props.State.age} type='number' onChange={handleInputChangeAge} placeholder={Text?.options ? Text.options[1] + ' (*)' : ''} />
                {/* <ValidationError error={error.age} /> */}

                <Input value={props.State.email} onChange={handleInputChangeEmail} placeholder={Text?.options ? Text.options[2] : ''} />
                <ValidationError error={error.email} />

                <select onChange={handleInputChangeBranch} className="min-w-[20rem] border rounded-md text-sm outline-none lg:px-4 px-2 lg:py-3 py-[0.6rem] placeholder:text-[#A1A1A1] text-[#101928] focus:border-[#8f8f8f] ease-in transition-all bg-white" id="">
                    <option value="">{Text?.options ? Text.options[3] + ' (*)' : ''}</option>
                    {items.map(item => (
                        <option key={item.name} value={item.name}>
                            {item.name}
                        </option>
                    ))}
                </select>
                {/* <select onChange={handleInputChangeBranch} className="min-w-[20rem] border rounded-md text-sm outline-none lg:px-4 px-2 lg:py-3 py-[0.6rem] placeholder:text-[#A1A1A1] text-[#101928] focus:border-[#8f8f8f] ease-in transition-all bg-white" id="">
                    <option value="">{Text?.options ? Text.options[3] + ' (*)' : ''}</option>
                    <option value="Link Shadman Road Lahore">Link Shadman Road Lahore</option>
                    <option value="Laxmi Chowk Lahore">Laxmi Chowk Lahore</option>
                    <option value="Raiwind Road Lahore">Raiwind Road Lahore</option>
                    <option value="1 KB Colony Airport Road Lahore">1 KB Colony Airport Road Lahore</option>
                    <option value="Gordon College Road Rawalpindi">Gordon College Road Rawalpindi</option>
                    <option value="Cricket Statium Rawalpindi">Cricket Statium Rawalpindi</option>
                    <option value="Bagh-e-Sardaran Rawalpindi">Bagh-e-Sardaran Rawalpindi</option>
                    <option value="Pir Wadhai Mor Rawalpindi">Pir Wadhai Mor Rawalpindi</option>
                    <option value="Blue Area Islamabad">Blue Area Islamabad</option>
                    <option value="Melodi Food Park Islamabad">Melodi Food Park Islamabad</option>
                    <option value="PWD Branch Islamabad">PWD Branch Islamabad</option>
                    <option value="GT Road Bahter Morr Wah Cantt">GT Road Bahter Morr Wah Cantt</option>
                </select> */}
                {/* <ValidationError error={error.branch} /> */}

                <div className='bg-white rounded-lg px-2 py-[0.4rem] text-black input_num'>
                    <PhoneInput defaultCountry="PK"
                        onChange={handleInputChangePhone}
                        placeholder={Text?.options ? Text.options[4]+ ' (*)' : ''}
                        value={props.State.phone}
                        limitMaxLength = 'true'
                    />
                </div>
                {/* <ValidationError error={error.phone} /> */}

                <div className={`flex items-center justify-center gap-5 flex-wrap ${Text?.lang == 'UR' && 'urdu'}`}>
                    <CircleIcon
                        onClick={() => { handleInputChangeGender('Male') }}
                        icon={
                            <Svgs.Male />
                        }
                        text={Text?.options ? Text.options[5] : ''}
                        selected={props.State.gender === 'Male'}
                    />
                    <CircleIcon
                        onClick={() => { handleInputChangeGender('Female') }}
                        icon={
                            <Svgs.Female />
                        }
                        text={Text?.options ? Text.options[6] : ''}
                        selected={props.State.gender === 'Female'}
                    />
                </div>
                <Button onClick={
                    () => {
                        handleChange()
                        // handleClick()
                    }
                } text='Submit' />
            </div>
        </div>
    )
}

export default Eight;

const ValidationError = ({ error }) => (
    <>{error && <div>{error}</div>}</>
);

function validateEmail(email) {
    debugger;
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return (true)
    }
    return (false)
}

//import React, { useEffect } from 'react'
//import { useState } from 'react'
//import CircleIcon from '../Common/CircleIcon'
//import Input from '../Common/Input'
//import Svgs from '../Common/Svgs'
//import PhoneInput from 'react-phone-number-input'
//import 'react-phone-number-input/style.css'
//import Button from '../Common/Button'
//import axios from 'axios'

//const Eight = (props) => {
//    // console.log('====================================');
//    // console.log(props.State);
//    // console.log('====================================');
//    const [state, setState] = useState({ phone: "" });
//    const handleInputChangeName = (param) => {
//        debugger;
//        props.setState({ ...props.State, name: param.target.value });
//    }
//    const handleInputChangeAge = (param) => {
//        props.setState({ ...props.State, age: param.target.value });
//    }
//    const handleInputChangeEmail = (param) => {
//        props.setState({ ...props.State, email: param.target.value });
//    }
//    const handleInputChangeBranch = (param) => {
//        props.setState({ ...props.State, branch: param.target.value });
//    }
//    const handleInputChangeGender = (param) => {
//        props.setState({ ...props.State, gender: param });
//    }
//    async function mediaBlob(mediaBlobUrl) {
//        const mediaBlob = await fetch(mediaBlobUrl).then(response => response.blob());
//        const myFile = new File(
//            [mediaBlob],
//            "video.mp4",
//            { type: 'video/mp4' }
//        );
//        //props.setState({ ...props.State, videoFile: myFile });
//        return myFile;
//    }

//    const handleChange = (param) => {
//        // console.log(props.State);
//        debugger;
//        const video = new File([props.State.video], "video.mp4");
//        const audio = new File([props.State.audio], "audio.mp3");
//        const formData = new FormData();
//        formData.append('video', video);
//        formData.append('audio', audio);
//        debugger;
//        for (const key in props.State) {
//            if (props.State.hasOwnProperty(key)) {
//                formData.append(key, props.State[key]);
//            }
//        }
//        // console.log(props.State);
//        debugger;
//        // const url = "http://localhost:38666/"; // Local URL
//        const url = "http://182.176.94.28:88/"; // Live URL
//        // const headers = { "Content-Type": "multipart/form-data", 'Authorization': 'nE0A8Um109Yrv0BHbf0BEpWd0aB0EqxvnDSfUnVwryqHFbc2+sxfwsjQssLRXKud' };

//        const headers = {
//            'Content-Type': 'multipart/form-data',
//            'Authorization': 'nE0A8Um109Yrv0BHbf0BEpWd0aB0EqxvnDSfUnVwryqHFbc2+sxfwsjQssLRXKud',
//            'Access-Control-Allow-Origin': 'http://182.176.94.28:81',
//            'Access-Control-Allow-Methods': 'GET, POST',
//            'Access-Control-Allow-Headers': 'Content-Type, Authorization',
//            'Access-Control-Allow-Credentials': 'true'
//        }

//        axios.post(url + 'api/Surveys/add', formData, { headers })
//            .then(response => {
//                debugger;
//                props.State.video = "";
//                props.State.audio = "";
//                props.State.name = "";
//                props.State.gender = "";
//                props.State.email = "";
//                props.State.experiance = "";
//                props.State.hear = "";
//                props.State.lang = "";
//                props.State.like = "";
//                props.State.phone = "";
//                props.State.recommend = '';
//                props.State.return = '';
//                props.State.revisit = '';
//                props.State.suggestions = '';
//                props.State.firstVisit = '';
//                // console.log(props.State);
//                // console.log(response.data.status);
//                props.setActive(props.Active + 1)
//            })
//            .catch((error) => { console.log(error) });
//    }
//    const [Text, setText] = useState([]);
//    useEffect(() => {
//        setText(props.Language)
//    }, [props.Language])

//    return (
//        <div className='slide-in-right  flex flex-col gap-6 items-center'>
//            <h1 className={`text-3xl font-extrabold ${Text?.lang == 'UR' && 'urdu'}`}>{Text.text}</h1>
//            <div className={`flex flex-col items-center gap-5 ${Text?.lang == 'UR' && 'urdu'}`}>
//                <Input onChange={handleInputChangeName} placeholder={Text?.options ? Text.options[0] : ''} />
//                <Input type='number' onChange={handleInputChangeAge} placeholder={Text?.options ? Text.options[1] : ''} />
//                <Input onChange={handleInputChangeEmail} placeholder={Text?.options ? Text.options[2] : ''} />
//                <select onChange={handleInputChangeBranch} className="min-w-[20rem] border rounded-md text-sm outline-none lg:px-4 px-2 lg:py-3 py-[0.6rem] placeholder:text-[#A1A1A1] text-[#101928] focus:border-[#8f8f8f] ease-in transition-all bg-white" id="">
//                    <option value="">{Text?.options ? Text.options[3] : ''}</option>
//                    <option value="Link Shadman Road Lahore">Link Shadman Road Lahore</option>
//                    <option value="Laxmi Chowk Lahore">Laxmi Chowk Lahore</option>
//                    <option value="Raiwind Road Lahore">Raiwind Road Lahore</option>
//                    <option value="1 KB Colony Airport Road Lahore">1 KB Colony Airport Road Lahore</option>
//                    <option value="Gordon College Road Rawalpindi">Gordon College Road Rawalpindi</option>
//                    <option value="Cricket Statium Rawalpindi">Cricket Statium Rawalpindi</option>
//                    <option value="Bagh-e-Sardaran Rawalpindi">Bagh-e-Sardaran Rawalpindi</option>
//                    <option value="Pir Wadhai Mor Rawalpindi">Pir Wadhai Mor Rawalpindi</option>
//                    <option value="Blue Area Islamabad">Blue Area Islamabad</option>
//                    <option value="Melodi Food Park Islamabad">Melodi Food Park Islamabad</option>
//                    <option value="GT Road Bahter Morr Wah Cantt">GT Road Bahter Morr Wah Cantt</option>
//                </select>
//                <div className='bg-white rounded-lg px-2 py-[0.4rem] text-black input_num'>
//                    <PhoneInput defaultCountry="PK"
//                        onChange={(e) => props.setState({ ...props.State, phone: e })}
//                        placeholder={Text?.options ? Text.options[4] : ''} />
//                </div>
//                <div className={`flex items-center justify-center gap-5 flex-wrap ${Text?.lang == 'UR' && 'urdu'}`}>
//                    <CircleIcon
//                        onClick={() => { handleInputChangeGender('Male') }}
//                        icon={
//                            <Svgs.Male />
//                        }
//                        text={Text?.options ? Text.options[5] : ''}
//                    />
//                    <CircleIcon
//                        onClick={() => { handleInputChangeGender('Female') }}
//                        icon={
//                            <Svgs.Female />
//                        }
//                        text={Text?.options ? Text.options[6] : ''}
//                    />
//                </div>
//                <Button onClick={
//                    () => {
//                        handleChange()
//                    }
//                } text='Submit' />
//            </div>
//        </div>
//    )
//}

//export default Eight